// TRE-1911 — trwający run workflow zapisany w localStorage, żeby po odświeżeniu
// karty w trakcie generowania dało się wznowić stream (odpowiednik MMKV-owego
// run-store z mobile: apps/mobile/src/screens/sales/agent/run-store.ts).

const ACTIVE_RUN_KEY = "salesAgentWorkflowActiveRun";

// Stream odpowiedzi nie powinien żyć dłużej — wznawianie prastarego runa grozi
// wiszeniem na streamie, który nic już nie wyprodukuje.
const ACTIVE_RUN_TTL_MS = 10 * 60 * 1000;

export type ActiveSalesAgentRun = {
  runId: string;
  runToken: string;
  sessionId: string | null;
  /** Właściciel — run zapisany na jednym koncie nie może wznowić się na innym. */
  userId: string;
  savedAt: number;
};

export const saveActiveRun = (run: Omit<ActiveSalesAgentRun, "savedAt">): void => {
  try {
    window.localStorage.setItem(ACTIVE_RUN_KEY, JSON.stringify({ ...run, savedAt: Date.now() }));
  } catch {
    // Pełny/zablokowany storage psuje tylko wznawianie, nie sam czat.
  }
};

export const loadActiveRun = (expectedUserId: string | null): ActiveSalesAgentRun | null => {
  try {
    const raw = window.localStorage.getItem(ACTIVE_RUN_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as ActiveSalesAgentRun;
    const isValid =
      Boolean(parsed.runId && parsed.runToken && parsed.userId) &&
      typeof parsed.savedAt === "number" &&
      Date.now() - parsed.savedAt < ACTIVE_RUN_TTL_MS &&
      Boolean(expectedUserId) &&
      parsed.userId === expectedUserId;

    if (!isValid) {
      window.localStorage.removeItem(ACTIVE_RUN_KEY);
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const clearActiveRun = (): void => {
  try {
    window.localStorage.removeItem(ACTIVE_RUN_KEY);
  } catch {
    // jak wyżej
  }
};
